// Auto-translated strings for IT/ES/DE/FR/PT (refine as needed).
import { createContext, useContext, useState, useMemo } from 'react';

const STRINGS = {
  en: {
    tagline: 'Discover the mysterious side of a city with trusted locals.',
    subtagline: "Your private doorway into the city's strange side.",
    book_cta: 'Book Ghostie Time',
    become_cta: 'Become a Ghostie',
    sign_in: 'Sign in',
    nav_home: 'Home',
    nav_what: "What's Ghostie",
    nav_book: 'Book',
    nav_become: 'Become a Ghostie',
    nav_blog: 'Blog',
    nav_gift: 'Gift Cards',
    nav_faq: 'FAQ',
    nav_about: 'About',
    nav_contact: 'Contacts',
    nav_reviews: 'Reviews',
    hero_desc: "Private mystery meetups with vetted local enthusiasts. Not a ghost tour. Not a script. A curated doorway into the city's strange side.",
    vetted_hosts: 'Vetted hosts',
    public_meeting: 'Public meeting points',
    private_curated: 'Private & curated',
    how_it_works: 'How it works',
    your_quest: 'Your mystery quest, in four steps',
    featured_cities: 'Featured cities',
    where_strange_lives: 'Where the strange side lives',
    choose_vibe: 'Choose your vibe',
    which_strange: 'Which strange side calls to you?',
    whispers: 'Whispers from travelers',
    stories_strange: 'Stories from the strange side',
    ready_summon: 'Ready to summon your local Ghostie?',
    pricing_line: '€50/hour/person · 2-hour minimum · private meetups only',
    not_paranormal: "We don't guarantee paranormal activity — we curate the strange side.",
  },
  it: {
    tagline: 'Scopri il lato misterioso di una città con local fidati.',
    subtagline: 'La tua porta privata sul lato strano della città.',
    book_cta: 'Prenota un Ghostie',
    become_cta: 'Diventa Ghostie',
    sign_in: 'Accedi',
    nav_home: 'Home', nav_what: "Cos'è Ghostie", nav_book: 'Prenota', nav_become: 'Diventa Ghostie',
    nav_blog: 'Blog', nav_gift: 'Gift Card', nav_faq: 'FAQ', nav_about: 'Chi siamo', nav_contact: 'Contatti', nav_reviews: 'Recensioni',
    hero_desc: 'Incontri privati di mistero con appassionati locali selezionati. Non un ghost tour. Non un copione. Una porta curata sul lato strano della città.',
    vetted_hosts: 'Host verificati', public_meeting: 'Punti di incontro pubblici', private_curated: 'Privato e curato',
    how_it_works: 'Come funziona', your_quest: 'La tua missione di mistero, in quattro passi',
    featured_cities: 'Città in evidenza', where_strange_lives: 'Dove vive il lato strano',
    choose_vibe: 'Scegli la tua vibe', which_strange: 'Quale lato strano ti chiama?',
    whispers: 'Sussurri dai viaggiatori', stories_strange: 'Storie dal lato strano',
    ready_summon: 'Pronto a evocare il tuo Ghostie locale?',
    pricing_line: '€50/ora/persona · minimo 2 ore · solo incontri privati',
    not_paranormal: 'Non garantiamo attività paranormali — curiamo il lato strano.',
  },
  es: {
    tagline: 'Descubre el lado misterioso de una ciudad con locales de confianza.',
    subtagline: 'Tu puerta privada al lado extraño de la ciudad.',
    book_cta: 'Reservar Ghostie', become_cta: 'Ser Ghostie', sign_in: 'Entrar',
    nav_home: 'Inicio', nav_what: 'Qué es Ghostie', nav_book: 'Reservar', nav_become: 'Ser Ghostie',
    nav_blog: 'Blog', nav_gift: 'Tarjetas regalo', nav_faq: 'FAQ', nav_about: 'Sobre nosotros', nav_contact: 'Contacto', nav_reviews: 'Reseñas',
    hero_desc: 'Encuentros privados de misterio con entusiastas locales verificados. No es un tour de fantasmas. No es un guion. Una puerta curada al lado extraño de la ciudad.',
    vetted_hosts: 'Anfitriones verificados', public_meeting: 'Puntos de encuentro públicos', private_curated: 'Privado y curado',
    how_it_works: 'Cómo funciona', your_quest: 'Tu misión de misterio, en cuatro pasos',
    featured_cities: 'Ciudades destacadas', where_strange_lives: 'Donde vive el lado extraño',
    choose_vibe: 'Elige tu vibra', which_strange: '¿Qué lado extraño te llama?',
    whispers: 'Susurros de viajeros', stories_strange: 'Historias del lado extraño',
    ready_summon: '¿Listo para invocar a tu Ghostie local?',
    pricing_line: '€50/hora/persona · mínimo 2 horas · solo encuentros privados',
    not_paranormal: 'No garantizamos actividad paranormal — curamos el lado extraño.',
  },
  de: {
    tagline: 'Entdecke die geheimnisvolle Seite einer Stadt mit vertrauten Locals.',
    subtagline: 'Deine private Tür zur seltsamen Seite der Stadt.',
    book_cta: 'Ghostie buchen', become_cta: 'Ghostie werden', sign_in: 'Anmelden',
    nav_home: 'Start', nav_what: 'Was ist Ghostie', nav_book: 'Buchen', nav_become: 'Ghostie werden',
    nav_blog: 'Blog', nav_gift: 'Gutscheine', nav_faq: 'FAQ', nav_about: 'Über uns', nav_contact: 'Kontakt', nav_reviews: 'Bewertungen',
    hero_desc: 'Private Mysterien-Treffen mit geprüften lokalen Enthusiasten. Keine Geistertour. Kein Skript. Eine kuratierte Tür zur seltsamen Seite der Stadt.',
    vetted_hosts: 'Geprüfte Gastgeber', public_meeting: 'Öffentliche Treffpunkte', private_curated: 'Privat & kuratiert',
    how_it_works: 'So funktioniert es', your_quest: 'Deine Mystery-Quest in vier Schritten',
    featured_cities: 'Empfohlene Städte', where_strange_lives: 'Wo die seltsame Seite lebt',
    choose_vibe: 'Wähle deinen Vibe', which_strange: 'Welche seltsame Seite ruft dich?',
    whispers: 'Flüstern von Reisenden', stories_strange: 'Geschichten von der seltsamen Seite',
    ready_summon: 'Bereit, deinen lokalen Ghostie zu beschwören?',
    pricing_line: '€50/Stunde/Person · 2-Stunden-Minimum · nur private Treffen',
    not_paranormal: 'Wir garantieren keine paranormalen Aktivitäten — wir kuratieren die seltsame Seite.',
  },
  fr: {
    tagline: 'Découvrez le côté mystérieux d\'une ville avec des locaux de confiance.',
    subtagline: 'Votre porte privée vers le côté étrange de la ville.',
    book_cta: 'Réserver un Ghostie', become_cta: 'Devenir Ghostie', sign_in: 'Se connecter',
    nav_home: 'Accueil', nav_what: "Qu'est-ce que Ghostie", nav_book: 'Réserver', nav_become: 'Devenir Ghostie',
    nav_blog: 'Blog', nav_gift: 'Cartes cadeaux', nav_faq: 'FAQ', nav_about: 'À propos', nav_contact: 'Contacts', nav_reviews: 'Avis',
    hero_desc: 'Rencontres privées de mystère avec des passionnés locaux vérifiés. Pas une visite fantôme. Pas un script. Une porte curée vers le côté étrange de la ville.',
    vetted_hosts: 'Hôtes vérifiés', public_meeting: 'Points de rencontre publics', private_curated: 'Privé & curé',
    how_it_works: 'Comment ça marche', your_quest: 'Votre quête mystère, en quatre étapes',
    featured_cities: 'Villes en vedette', where_strange_lives: 'Où vit le côté étrange',
    choose_vibe: 'Choisis ton ambiance', which_strange: 'Quel côté étrange t\'appelle ?',
    whispers: 'Murmures de voyageurs', stories_strange: 'Histoires du côté étrange',
    ready_summon: 'Prêt à invoquer ton Ghostie local ?',
    pricing_line: '€50/heure/personne · minimum 2 heures · uniquement rencontres privées',
    not_paranormal: 'Nous ne garantissons pas d\'activité paranormale — nous curons le côté étrange.',
  },
  pt: {
    tagline: 'Descubra o lado misterioso de uma cidade com locais confiáveis.',
    subtagline: 'Sua porta privada para o lado estranho da cidade.',
    book_cta: 'Reservar Ghostie', become_cta: 'Seja um Ghostie', sign_in: 'Entrar',
    nav_home: 'Início', nav_what: 'O que é Ghostie', nav_book: 'Reservar', nav_become: 'Seja Ghostie',
    nav_blog: 'Blog', nav_gift: 'Cartões-presente', nav_faq: 'FAQ', nav_about: 'Sobre', nav_contact: 'Contato', nav_reviews: 'Avaliações',
    hero_desc: 'Encontros privados de mistério com entusiastas locais verificados. Não é um tour fantasma. Não é um roteiro. Uma porta curada para o lado estranho da cidade.',
    vetted_hosts: 'Anfitriões verificados', public_meeting: 'Pontos de encontro públicos', private_curated: 'Privado & curado',
    how_it_works: 'Como funciona', your_quest: 'Sua missão de mistério, em quatro passos',
    featured_cities: 'Cidades em destaque', where_strange_lives: 'Onde vive o lado estranho',
    choose_vibe: 'Escolha sua vibe', which_strange: 'Qual lado estranho te chama?',
    whispers: 'Sussurros de viajantes', stories_strange: 'Histórias do lado estranho',
    ready_summon: 'Pronto para invocar seu Ghostie local?',
    pricing_line: '€50/hora/pessoa · mínimo 2 horas · apenas encontros privados',
    not_paranormal: 'Não garantimos atividade paranormal — curamos o lado estranho.',
  },
};

const LangCtx = createContext({ lang: 'en', setLang: () => {}, t: (k) => k });

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem('ghostie_lang') || 'en');
  const value = useMemo(() => ({
    lang,
    setLang: (l) => { setLang(l); localStorage.setItem('ghostie_lang', l); },
    t: (k) => (STRINGS[lang] && STRINGS[lang][k]) || STRINGS.en[k] || k,
  }), [lang]);
  return <LangCtx.Provider value={value}>{children}</LangCtx.Provider>;
}

export const useI18n = () => useContext(LangCtx);
export const LANGS = [
  { code: 'en', label: 'EN' }, { code: 'it', label: 'IT' }, { code: 'es', label: 'ES' },
  { code: 'de', label: 'DE' }, { code: 'fr', label: 'FR' }, { code: 'pt', label: 'PT' },
];
